import React from 'react'

import { number, oneOf, string } from 'prop-types'

function FeatureCard({ variant, title, description, imageSrc, imageWidth, imageHeight }) {
  return (
    <div className={`create-with-ai__card create-with-ai__card--${variant}`}>
      <div className="create-with-ai__card-text">
        <h3 className="create-with-ai__card-title cgt-heading-400">{title}</h3>
        <p className="create-with-ai__card-desc cgt-body-md">{description}</p>
      </div>
      <img
        className={`create-with-ai__card-img create-with-ai__card-img--${variant}`}
        src={imageSrc}
        alt=""
        aria-hidden="true"
        loading="lazy"
        width={imageWidth}
        height={imageHeight}
      />
    </div>
  )
}

FeatureCard.propTypes = {
  variant: oneOf(['image', 'text', 'enhance']).isRequired,
  title: string.isRequired,
  description: string.isRequired,
  imageSrc: string.isRequired,
  imageWidth: number.isRequired,
  imageHeight: number.isRequired,
}

export default FeatureCard
